<div class="main-container">
    <h1>404 - Pagina niet gevonden</h1>
    <p>
        De opgevraagde URL bestaat niet. Ga terug naar de website en probeer het opnieuw.
    </p>
</div>
